import { createStore } from 'cross-state';

export const recentEntitiesStore = createStore<string[]>([], {
  persist: { id: 'recentEntities', storage: localStorage, paths: [''] },
});

export function addRecentEntity(entityId: string) {
  recentEntitiesStore.set((entries) =>
    entries
      .filter((e) => e !== entityId)
      .concat([entityId])
      .slice(-10),
  );
}

export function useRecentEntries() {
  return recentEntitiesStore.useStore();
}
